const Pourquoi = () => (
  <section className="ppb-why" id="pourquoi">
    <div className="ppb-why-glow" aria-hidden="true" />
    <div className="container">
      <div className="ppb-why-head">
        <p className="ppb-eyebrow on-dark">Pourquoi GS Sanaa</p>
        <h2 className="ppb-section-title on-dark">
          Une prépa <span className="emph">exigeante</span>, un suivi sur mesure.
        </h2>
      </div>

      <div className="ppb-why-grid">
        <article className="ppb-atout">
          <p className="ppb-atout-num">01</p>
          <h3 className="ppb-atout-title">Préparation intensive &amp; ciblée aux concours</h3>
          <p className="ppb-atout-body">
            Un entraînement type concours (Médecine, ENCG, ENSA…) rythmé par des
            simulations et le travail des annales, pour aborder les épreuves
            dans les conditions réelles.
          </p>
        </article>

        <article className="ppb-atout">
          <p className="ppb-atout-num">02</p>
          <h3 className="ppb-atout-title">Encadrement personnalisé &amp; suivi régulier</h3>
          <p className="ppb-atout-body">
            Chaque candidat est accompagné de près au sein de groupes à effectif
            maîtrisé, avec un suivi régulier de sa progression jusqu'au jour J.
          </p>
        </article>
      </div>

      <p className="ppb-why-closing">École à taille humaine, depuis 1997.</p>
    </div>
  </section>
);

export default Pourquoi;
